export default "__VITE_ASSET__C6a8xtrI__"